import { TUserContactSupport } from '@/types/User.types';

export const requestCustomerSupportPost = async ({
  email,
  message,
  turnstileToken,
}: TUserContactSupport & { turnstileToken: string }) => {
  if (email.length === 0 || message.length === 0)
    throw Error(`Email and message can't be empty`, { cause: 'Empty content' });

  const payload = {
    email,
    message,
    turnstileToken,
  };

  await fetch('https://restless-wildflower-e9c2.anant-asthana.workers.dev', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  return 'ok';
};
